import { createSlice } from "@reduxjs/toolkit";
import { getChefListAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const getChefListSlice = createSlice({
  name: "getChefList",
  initialState: data,
  reducers: {
    getChefListSlice(state) {
      state.isLoading = true;
    },
    getChefListSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getChefListSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getChefListSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getChefListHandler = (long:any,lat:any) => async (dispatch: any) => {
  try {
    dispatch(getChefListAction.getChefListSlice());
    const response: any = await getChefListAPI(long,lat);

    dispatch(getChefListAction.getChefListSliceSuccess(response));
  } catch (e: any) {
    dispatch(getChefListAction.getChefListSliceFailure(e?.response?.data));
  }
};
export default getChefListSlice.reducer;
export const getChefListAction = getChefListSlice.actions;
